import { motion } from "framer-motion";
import { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeProvider";
import { LanguageContext } from "../../contexts/LanguageProvider";
export default function AISection() {
  const { colorsObj } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);
  return (
    <section
      className=" py-16 px-6 lg:px-24 text-gray-800 dark:text-gray-100"
      style={{
        backgroundColor: colorsObj.colorBackground,
      }}
    >
      <div className="text-center mb-12">
        <h2
          className="text-4xl font-bold mb-4 "
          style={{ color: colorsObj.colorPrimary }}
        >
          {t("home-ai-title")}
        </h2>
        <p
          className="text-lg max-w-2xl mx-auto "
          style={{
            color: colorsObj.colorText,
          }}
        >
          {t("home-ai-subtitle")}
        </p>
      </div>

      <div className="flex flex-col-reverse gap-12 md:gap-4 md:flex-row items-center justify-between w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:w-1/2 mx-auto">
          {[
            {
              emoji: "💬",
              text: t("home-ai-feature-1"),
            },
            { emoji: "📅", text: t("home-ai-feature-2") },
            { emoji: "⏱️", text: t("home-ai-feature-3") },
            {
              emoji: "📄",
              text: t("home-ai-feature-4"),
            },
            {
              emoji: "🔍",
              text: t("home-ai-feature-5"),
            },
            { emoji: "📊", text: t("home-ai-feature-6") },
          ].map(({ emoji, text }, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.4 }}
              viewport={{ once: true }}
              className=" p-4 text-xs md:text-lg md:p-6  rounded-xl shadow hover:shadow-md transition"
              style={{
                backgroundColor: colorsObj.colorOverlay + "80",
                color: colorsObj.colorText,
              }}
            >
              <div className="text-3xl mb-4">{emoji}</div>
              <p>{text}</p>
            </motion.div>
          ))}
        </div>
        <div className="max-w-[250px] md:max-w-full md:w-4/12 p-4 bg-[#161616] rounded-2xl">
          <motion.img
            src="/gif-ai.gif"
            alt="Hero phone"
            className="md:w-8/12 w-full mx-auto   "
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.4 }}
            viewport={{ once: true }}
          />
        </div>
      </div>
    </section>
  );
}
